/* eslint-disable  @typescript-eslint/no-explicit-any */
import {Component, Vue} from 'vue-property-decorator';

/**
 * Expose `isMobile` a un composant.
 *
 * Une SEULE definition du seuil pour toute l'application : chaque page qui
 * recalculait sa propre largeur finissait avec son propre seuil, et deux ecrans
 * basculaient a deux moments differents.
 *
 * 992px est le seuil de Metronic (`lg`), celui des classes `d-lg-none` deja
 * presentes et celui de la barre d'onglets du bas. Le meme partout.
 *
 * `matchMedia` plutot qu'un ecouteur de `resize` : il ne se declenche qu'au
 * franchissement du seuil, pas a chaque pixel de redimensionnement.
 */
export const MOBILE_BREAKPOINT = 991.98;

@Component
export default class MobileAware extends Vue {
  isMobile = false;
  private mobileQuery: MediaQueryList | null = null;
  private mobileListener: ((e: any) => void) | null = null;

  created() {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return;
    }
    this.mobileQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    this.isMobile = this.mobileQuery.matches;
    this.mobileListener = (e: any) => {
      this.isMobile = e.matches;
    };
    // addListener : deprecie mais seul dispo sur les Safari < 14, encore
    // repandus sur les iPhone en circulation ici.
    if (this.mobileQuery.addEventListener) {
      this.mobileQuery.addEventListener('change', this.mobileListener);
    } else if ((this.mobileQuery as any).addListener) {
      (this.mobileQuery as any).addListener(this.mobileListener);
    }
  }

  beforeDestroy() {
    if (!this.mobileQuery || !this.mobileListener) {
      return;
    }
    if (this.mobileQuery.removeEventListener) {
      this.mobileQuery.removeEventListener('change', this.mobileListener);
    } else if ((this.mobileQuery as any).removeListener) {
      (this.mobileQuery as any).removeListener(this.mobileListener);
    }
  }
}
